import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { LinkButton } from '@/components/ui/Button/LinkButton';
export const ProfessionalRfpProposalListLink = (props) => {
    const { badgeNumber, className = '', color, disabled, href, text } = props;
    return (_jsxs(LinkButton, Object.assign({ className: clsx('w-[90px] h-[30px]', className), color: color, disabled: disabled, size: 'fluid', textClassName: 'text-11', to: href }, { children: [text, badgeNumber > 0 && (_jsx(NumberBadge, { className: 'absolute top-[-6px] right-[-8px]', number: badgeNumber }))] })));
};
